import { Stack, Typography } from '@mui/material';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import formatSecondsToHours from 'legacyfrontend/utils/formatSecondsToHours';
import { getScaleInfo } from 'legacyfrontend/utils/getScaleInfo';
const IndicateScaleCard = ({ info }) => {
  const formattedInfo = getScaleInfo(info);

  return (
    <div className='indicate_scale_card'>
      <Stack alignItems='center' flexDirection='row' gap={2}>
        <AirlineStopsIcon />
        <Stack flexDirection='column'>
          <Typography>{`Escala (${formattedInfo.text})`}</Typography>
          <Typography>{`Duración ${formatSecondsToHours(info.waitTime)}`}</Typography>
        </Stack>
      </Stack>
    </div>
  );
};

export default IndicateScaleCard;
